import { Component } from '@angular/core';


/**
 * Component
 */
@Component({
  selector: 'app-application-configuration',
  templateUrl: './application-configuration.component.html',
  styleUrls: ['./application-configuration.component.css'],
  standalone: false
})
export class ApplicationConfigurationComponent {}
